import apiClient from "./apiClient";

export const getMyProfile = () => apiClient.get("/user-profiles/my-profile");
export const updateMyProfile = (data) => apiClient.put(`/user-profiles/my-profile`, data);
export const updatePassword = (data) => apiClient.put(`/user-profiles/update-password`, data);
